fetch('/icons.svg')
    .then(response => response.text())
    .then(data => document.body.insertAdjacentHTML('afterbegin', data))
